import { shallowEqual, useSelector } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useScreenshot } from 'use-react-screenshot'
import { UploadPhoto } from '../../s3Func/s3Upload';
import { toPng } from 'html-to-image';


import './Animal.scss';
import Webcam from 'react-webcam';


const Animal = (props) => {

    const navigate = useNavigate();
    function sleep(ms) {return new Promise((resolve) => setTimeout(resolve, ms));}
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);
    const ref = useRef(null)
    const webcamRef = useRef(null)
    // const [image, takeScreenshot] = useScreenshot({ type: 'image/png', quality: 1.0})
    // const getImage = () => setTimeout(() => { takeScreenshot(ref.current, { letterRendering: true, allowTaint: true, useCORS: true, backgroundColor: null})}, 1000); 
    const [takePhoto, setTakePhoto] = useState(null)
    const [image, setImage] = useState(null)
    const getImage = () => {
        if (!ref.current || !webcamRef.current) {
            console.error('Node or webcam not found for screenshot.');
            return;
          }
        setTakePhoto(webcamRef.current.getScreenshot())
        const node = document.getElementById('screenshot');
        setTimeout(() => {
            // ios/macos redundant painting
            toPng(node, { height: node.offsetHeight, width: node.offsetWidth, quality: 1 })
            .then(() => {
              toPng(node, { height: node.offsetHeight, width: node.offsetWidth, quality: 1 })
              .then(() => {
                toPng(node, { height: node.offsetHeight, width: node.offsetWidth, quality: 1 })
                .then(() => {
                  toPng(node, { height: node.offsetHeight, width: node.offsetWidth, quality: 1 })
                  .then(() => {
                    toPng(node, { height: node.offsetHeight, width: node.offsetWidth, quality: 1 })
                    .then((dataUrl) => {
                        setImage(dataUrl);
                    })
                    })
                    })
                })
            })
            .catch((error) => {
            //   console.error('oops, something went wrong!', error);
              alert('Ooops! Something went wrong. Try again.');
            });
        
        }, 1500);
    }

    const cancel = async () => {
        props.setDisplayAnimal(false)
        await sleep(1);
        props.setDisplayAnimal(true)
    }

    const submit = async () => {
        const result = await UploadPhoto(image, 'userfiles', `${props.level}_${props.topic}_animal.png`, 'image/png', login.studentid);
        if (result === 200){
            if(props.setPrize){
                props.setDisplayAnimal(false)
                props.setPrize(true)
            }
            else{
                await props.getAnimals();
                props.finish();
            }
        }
        else{
            window.alert('Whoops, failed to upload. It looks like the internet connection was lost. Please try again after login.');
        }
    }

    function isIOS() {
        return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    function isLandscape() {
        return window.matchMedia("(orientation: landscape)").matches;
    }

    const videoConstraints = {
        width: props.width,
        height: props.height,
        facingMode: "user",
    };

    const videoConstraints2 = {
        height: props.width,
        width: props.height,
        facingMode: "user",
    };
    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

    const coin = generateImageUrl('images/Images/Coin_Empty.png');
    const cameraIcon = generateImageUrl('images/Images/Camera_4x.png');
    const confirmIcon = generateImageUrl('images/Module1Images/check_button_small.png');
    const cancelIcon = generateImageUrl('images/Module1Images/x_button.png');
    const cameraAudioSound = generateImageUrl('media/Module1Videos/camera_shutter.m4a');
    const cameraAudio = new Audio(cameraAudioSound);
    return (
        <div className='animalBody'>
            <div className='title'>
                {image ? <h1>To add this image to your scene, go to the store and click on "Your Characters".</h1>
                : <h1>Congratulations! You completed all of the topics in this conversation. Match your face to the hole and take a picture.</h1>}
            </div>
            {image && <img className={`image animal_size`}  src={image} alt={'Screenshot'} />}
            {image && <div className='preview'>
                <button onClick={cancel}>
                    <img src={cancelIcon} alt='cancel' />
                </button>

                <button onClick={submit}>
                    <img src={confirmIcon} alt='confirm' />
                </button>
            </div>}
            {!image &&<div className={`cameraAnimal ${props.animalName}-large`} id="screenshot" ref={ref}>
                <img alt='animal mask' className={`animal animal_size ${props.animalName}-large`} src={props.animal} />
                <div className={`camera ${props.animalName}`} >
                    {!takePhoto ? <Webcam
                        style={{borderRadius:"80%"}}
                        ref={webcamRef}
                        muted
                        mirrored={true}
                        videoConstraints={(isIOS() && !isLandscape()) ? videoConstraints2 : videoConstraints}
                        /> : <img style={{borderRadius:"80%"}} src={takePhoto}/>}
                </div>
            </div>}
            {!image && <button className='take' onClick={()=>{getImage(); cameraAudio.play()}}>
                <img src={cameraIcon} alt='camera icon' />
            </button>}
        </div>
    );
};
export default Animal;